import type { SVGProps } from 'react';

export const PaperClipIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.333 5.666a1 1 0 0 0-1 1v9c0 2.758-2.242 5-5 5s-5-2.242-5-5V6.333c0-1.655 1.346-3 3-3 1.655 0 3 1.345 3 3v9.333a1 1 0 0 1-2 0v-9a1 1 0 0 0-2 0v9c0 1.655 1.346 3 3 3 1.655 0 3-1.345 3-3V6.333c0-2.757-2.242-5-5-5s-5 2.243-5 5v9.333c0 3.86 3.14 7 7 7s7-3.14 7-7v-9a1 1 0 0 0-1-1"
      fill="currentColor"
    />
  </svg>
);
